import axios from 'axios'
import Servers from "../../server"
export default {
  namespaced: true,
  state: {
    comunityObject: {},
    edit: false,
    reloadNotices: false,
  },
  mutations: {
    setComunity(state, obj) {
      state.comunityObject = obj;
    },
    setEdit(state, obj) {
      state.edit = obj;
    },
    setReloadNotices(state, value) {
      state.reloadNotices = value;
    },
  },
  getters: {
    getComunity(state) {
      return state.comunityObjct;
    },
    getEdit(state) {
      return state.edit;
    },
  },
  actions: {
    async getInfoNotice(context, uuid) {
      let response = await axios.get(
        Servers.serverApi + "api/notices/" + uuid,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        },
      );

      let objt = response.data;

      context.commit("setComunity", objt);
      context.commit("setEdit", true);
      return;
    },

    async getInfoNewsletter(context, uuid) {
      let response = await axios.get(
        Servers.serverApi + "api/newsletters/" + uuid,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        },
      );

      let objt = response.data;

      context.commit("setComunity", objt);
      context.commit("setEdit", true);
      return;
    },
    async getInfoPromotion(context, uuid) {
      let response = await axios.get(
        Servers.serverApi + "api/promotions/" + uuid,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        },
      );

      let objt = response.data;

      context.commit("setComunity", objt);
      context.commit("setEdit", true);
      return;
    },
  },
};